import { useLayoutEffect, useState, type RefObject } from "react";

export function useScrollAreaOverflow(
  ref: RefObject<HTMLElement | null>,
  enabled = true,
  deps: unknown[] = [],
) {
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    if (!enabled) {
      setOverflows(false);
      return;
    }

    const el = ref.current;
    if (!el) return;

    const measure = () => {
      setOverflows(el.scrollHeight > el.clientHeight + 1);
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
    // deps drives re-measure when inner content changes height
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ref, ...deps]);

  return overflows;
}
